'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var style = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeWidth: 3
};

var ChecklistAppIcon = function ChecklistAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({
    viewBox: "0 0 49.22 58.25"
  }, props), React__default["default"].createElement("polygon", {
    style: style,
    points: "3.11 2.57 3.11 2.57 46.49 2.57 46.49 55.59 3.11 55.59 3.11 2.57"
  }), React__default["default"].createElement("line", {
    style: style,
    x1: "38.05",
    y1: "14.62",
    x2: "26",
    y2: "14.62"
  }), React__default["default"].createElement("line", {
    style: style,
    x1: "38.05",
    y1: "29.08",
    x2: "26",
    y2: "29.08"
  }), React__default["default"].createElement("polyline", {
    style: style,
    points: "11.54 14.62 13.95 17.03 19.98 11"
  }), React__default["default"].createElement("polyline", {
    style: style,
    points: "11.54 29.08 13.95 31.49 19.98 25.46"
  }), React__default["default"].createElement("line", {
    style: style,
    x1: "38.05",
    y1: "43.62",
    x2: "26",
    y2: "43.62"
  }), React__default["default"].createElement("polyline", {
    style: style,
    points: "11.54 43.62 13.95 46.03 19.98 40.01"
  }));
};

var ChecklistAppIcon$1 = iconStyles()(ChecklistAppIcon);

module.exports = ChecklistAppIcon$1;
